import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/useAuth';
import { Select, Button, Table, Tag, Card, Row, Col, Typography, DatePicker } from 'antd';
import PrintButton from '../../../components/admin/PrintButton';

const { Option } = Select;
const { Title } = Typography;
const { RangePicker } = DatePicker;

const ReportsListReport = () => {
  const [reports, setReports] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    userId: null,
    dates: null,
  });
  const { token } = useAuth();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await api.get('/api/users', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUsers(response.data);
      } catch (error) {
        console.error('Failed to fetch users for filter', error);
      }
    };
    if (token) {
      fetchUsers();
    }
  }, [token]);

  const fetchReports = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.status && filters.status !== 'all') {
        params.status = filters.status;
      }
      if (filters.userId) {
        params.userId = filters.userId;
      }
      if (filters.dates && filters.dates.length === 2) {
        params.startDate = filters.dates[0].toISOString();
        params.endDate = filters.dates[1].toISOString();
      }
      const response = await api.get('/api/reports', {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setReports(response.data);
    } catch (error) {
      console.error('Failed to fetch reports', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    fetchReports();
  };

  useEffect(() => {
    fetchReports();
  }, [token]);

  const columns = [
    { title: 'العنوان', dataIndex: 'title', key: 'title' },
    { title: 'المؤلف', dataIndex: ['user', 'username'], key: 'author' },
    {
      title: 'الحالة',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'published' ? 'green' : 'orange'}>
          {status === 'published' ? 'منشور' : 'مسودة'}
        </Tag>
      ),
    },
    {
      title: 'تاريخ النشر',
      dataIndex: 'publishDate',
      key: 'publishDate',
      render: (date) => (date ? new Date(date).toLocaleDateString('ar-SA') : 'N/A'),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={3}>قائمة التقارير</Title>
        <PrintButton />
      </div>
      <Card title="قائمة التقارير">
        <div>
          <Row gutter={16} style={{ marginBottom: 16 }} className="no-print">
            <Col>
              <Select
                placeholder="اختر الحالة"
                style={{ width: 150 }}
                onChange={(value) => handleFilterChange('status', value)}
                defaultValue="all"
              >
                <Option value="all">الكل</Option>
                <Option value="published">منشور</Option>
                <Option value="draft">مسودة</Option>
              </Select>
            </Col>
            <Col>
              <Select
                placeholder="اختر المؤلف"
                style={{ width: 200 }}
                onChange={(value) => handleFilterChange('userId', value)}
                allowClear
              >
                {users.map((user) => (
                  <Option key={user.id} value={user.id}>
                    {user.username}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col>
              <RangePicker
                onChange={(dates) => handleFilterChange('dates', dates)}
                placeholder={['تاريخ البدء', 'تاريخ الانتهاء']}
              />
            </Col>
            <Col>
              <Button type="primary" onClick={handleSearch}>
                بحث
              </Button>
            </Col>
          </Row>
          <Table
            dataSource={reports}
            columns={columns}
            rowKey="id"
            loading={loading}
            scroll={{ x: true }}
          />
        </div>
      </Card>
    </div>
  );
};

export default ReportsListReport;